<div>
  <h4>Replication for this Blob Storage Container needs to be configured.</h4>
</div>
<div class="margin-top">
  {{ uiService.productName }} will create a clone of this blob container in the recovery environment and optionally
  replicate its contents.
</div>
<form [formGroup]="configFormModel" (ngSubmit)="saveClick()" class="form-controls">
  <div>
    <div class="control-header-with-instructions">
      <h4 class="spacer">How should {{ uiService.productName }} recover this blob container?</h4>
    </div>
    <div class="arpio-radio-container">
      <div class="margin-top"></div>
      <label class="arpio-radio">
        <input id="object-replication-mode" type="radio" formControlName="objectReplicationMode" value="none" />
        <span class="radio-label strong-text">Recover the blob container but not its contents</span>
        <div>
          Choose this option for blob containers containing ephemeral data or data that is not relevant in the recovery
          environment (such as logs). A clone of this blob container will be created in the recovery environment but
          {{ uiService.productName }} will not manage its contents.
        </div>
      </label>
      <div class="margin-top"></div>
      <label class="arpio-radio">
        <input id="object-replication-mode" type="radio" formControlName="objectReplicationMode" value="realTime" />
        <span class="radio-label strong-text"> Recover the blob container and its contents </span>
        <div>
          Choose this option for blob containers containing persisted application data. A clone of this container will
          be created in the recovery environment and objects in this container will be replicated into the cloned
          container via <a target="_blank" href="{{ uiService.azureBlobReplicationUrl }}">block blob replication</a>.
        </div>
      </label>
      <ng-container *ngIf="objectReplicationMode == 'realTime'">
        <div class="flex-bottom-row">
          <div class="full-width">
            <div class="flex-center-row control-header-with-instructions">
              <h4 class="spacer">Objects To Backfill</h4>
              <h4>{{ backfillRangeText }}</h4>
            </div>
            <div class="control-header-instructions">
              Specify the timeframe of objects to backfill into this new blob container.
            </div>
            <input
              id="back-fill-range"
              class="full-width"
              type="range"
              min="0"
              [max]="backfillOptions.length - 1"
              formControlName="backfillRange"
            />
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="flex-center-row control-header">
    <div class="spacer"></div>
    <button type="submit" class="arpio-button" [disabled]="!validConfig">
      <ng-container [ngSwitch]="saveStatus">
        <i *ngSwitchCase="'saving'" class="fa-solid fa-spinner fa-spin"></i>
        <i *ngSwitchCase="'saved'" class="fa-utility fa-semibold fa-check"></i>
        <ng-container *ngSwitchDefault>SAVE</ng-container>
      </ng-container>
    </button>
  </div>
</form>
